import React from 'react'
import Breadcrumb from "../../../common/Breadcrumb";
import SubscribArea from "../../../common/SubscribArea";
import BlogDetailsWrap4 from "../Digitalizareinstitutiipublice/BlogDetailsWrap4";
import SEO from '@americanexpress/react-seo';



function BlogDetails4() {
  return (
    <>
      <SEO
        title="e-Brandy - Digitalizare și branding afacere | Agenție Promovare Online"
        description="Agentie Web Design Romania, Web Design Timisoara, Promovare online 100%"
        keywords={['agentie', 'web design']}
        siteUrl="https://e-brandy.ro"
        image={{
          src: 'https://e-brandy.ro/img/logo.png'
        }}
      />
      <Breadcrumb pageName="Digitalizare in insitutiile publice din Romania" pageTitle="Digitalizare in insitutiile publice</br> din Romania" />
      <BlogDetailsWrap4 />
      <SubscribArea />

    </>
  )
}

export default BlogDetails4
